/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserMutationResponse, UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUser";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { usersAuthzAPIAdminPermissionsWriteAllowPermissionToUser } from "../axios/usersAuthzAPIAdminPermissionsWriteAllowPermissionToUser";
import { useMutation } from "@tanstack/react-query";

export const usersAuthzAPIAdminPermissionsWriteAllowPermissionToUserMutationKey = () => ["users-authz-api", { url: '/admin/user/:userId/permissions/:permission/allow' }] as const

export type UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserMutationKey = ReturnType<typeof usersAuthzAPIAdminPermissionsWriteAllowPermissionToUserMutationKey>

/**
 * @summary Allow a permission for a user
 * {@link /admin/user/:userId/permissions/:permission/allow}
 */
export function useUsersAuthzAPIAdminPermissionsWriteAllowPermissionToUser<TContext>(options: 
{
  mutation?: UseMutationOptions<UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserMutationResponse, ResponseErrorConfig<Error>, {userId: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserPathParams["permission"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? usersAuthzAPIAdminPermissionsWriteAllowPermissionToUserMutationKey()

  return useMutation<UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserMutationResponse, ResponseErrorConfig<Error>, {userId: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserPathParams["userId"], permission: UsersAuthzAPIAdminPermissionsWriteAllowPermissionToUserPathParams["permission"]}, TContext>({
    mutationFn: async({ userId, permission }) => {
      return usersAuthzAPIAdminPermissionsWriteAllowPermissionToUser(userId, permission, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}